import { useQuery } from "@tanstack/react-query";
import { getDashboardRegistry } from "../../../api/dashboardsApi";
import { SearchableDashboard } from "../../../constants/searchableDashboards";

export const DASHBOARD_REGISTRY_QUERY_KEY = ["dashboards"];

// The single shared source every dashboard-aware page reads from (Home search, Dashboards page,
// Favourites, Analysis picker, Settings' Engagement panel) - one cache, one place to swap the mock
// resolver for the real GET /dashboards endpoint later without touching any consumer.
export const useDashboardRegistry = () => {
  const { data, isLoading, isFetching, refetch } = useQuery<SearchableDashboard[]>(DASHBOARD_REGISTRY_QUERY_KEY, getDashboardRegistry, {
    // Registry is presentation metadata with no admin UI to invalidate against anymore (matches
    // BACKEND_TASKS.md's own "long staleTime" note for this endpoint) - the admin category-
    // assignment action that used to patch this cache directly on success has been removed from
    // the frontend.
    staleTime: Infinity,
  });

  return { dashboards: data ?? [], isLoading, isFetching, refetch };
};
